// import { Link, useLocation } from "react-router-dom";
// import React from "react";
// import breadcrumbImage from "../assets/images/breadcrumb.webp";

// const Breadcrumb = () => {
//     const location = useLocation();
//     const pathnames = location.pathname.split("/").filter((x) => x);

//     const formatText = (str) =>
//         str
//             .replace(/_/g, " ")
//             .replace(/\b\w/g, (char) => char.toUpperCase());

//     const nonLinkCategories = ["fruits", "vegetables", "herbs"];

//     return (
//         <div className="dz-bnr-inr mb-5"
//             style={{
//                 backgroundImage: `url(${breadcrumbImage})`,
//                 backgroundSize: "cover",
//                 backgroundPosition: "center",
//                 position: "relative",
//                 minHeight: "55px",
//                 display: "flex",
//                 alignItems: "center",
//                 color: "white"
//             }}>
//            <div
//         style={{
//           position: "absolute",
//           inset: 0,
//           backgroundColor: "rgba(0, 0, 0, 0.7)",
//           zIndex: 1,
//         }}
//       ></div>
//             <div className="container position-relative" style={{ position: "relative", zIndex: 999 }}>
//                 <div className="dz-bnr-inr-entry">
//                     <nav aria-label="breadcrumb" className="breadcrumb-row">
//                         <ul className="breadcrumb">
//                             <li className="breadcrumb-item">
//                                 <Link to="/">Home</Link>
//                             </li>
//                             {pathnames.map((value, index) => {
//                                 const to = `/${pathnames.slice(0, index + 1).join("/")}`;
//                                 const isLast = index === pathnames.length - 1;
//                                 const isNonLinkCategory = nonLinkCategories.includes(value.toLowerCase());
//                                 const formattedValue = formatText(value);

//                                 return (
//                                     <li key={to} className="breadcrumb-item">
//                                         <span className="mx-2">/</span>
//                                         {isLast || isNonLinkCategory ? (
//                                             <span>{formattedValue}</span>
//                                         ) : (
//                                             <Link to={to}>{formattedValue}</Link>
//                                         )}
//                                     </li>
//                                 );
//                             })}
//                         </ul>
//                     </nav>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default React.memo(Breadcrumb);


import { Link, useLocation } from "react-router-dom";
import React from "react";
import breadcrumbImage from "../assets/images/breadcrumb.webp";

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const formatText = (str) =>
    str.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  const nonLinkCategories = ["fruits", "vegetables", "herbs"];

  return (
    <div className="dz-bnr-inr mb-5">
      <div className="img-wrapper">
        <img
          src={breadcrumbImage}
          alt="Breadcrumb Banner"
          width="1920"
          height="55"
          decoding="async"
          loading="eager"
          fetchPriority="high"
        />
        <div className="overlay" />
        <div className="content">
          <div className="container">
            <div className="dz-bnr-inr-entry">
              <nav aria-label="breadcrumb" className="breadcrumb-row">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  {pathnames.map((value, index) => {
                    const to = `/${pathnames.slice(0, index + 1).join("/")}`;
                    const isLast = index === pathnames.length - 1;
                    const isNonLinkCategory = nonLinkCategories.includes(value.toLowerCase());
                    const formattedValue = formatText(value);

                    return (
                      <li key={to} className="breadcrumb-item">
                        <span className="mx-2">/</span>
                        {isLast || isNonLinkCategory ? (
                          <span>{formattedValue}</span>
                        ) : (
                          <Link to={to}>{formattedValue}</Link>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Breadcrumb);

